import {LoginRequest} from "scholastic-client-components/src/api/authAPI"
import {APIRequest, callAPI} from "./axiosDriver"

export interface ResetRequest extends Pick<LoginRequest, "email"> {}

interface ResetResponse {
    nonConfirmedAccount?: boolean
}

const reset: APIRequest<ResetRequest, ResetResponse> = (params) => {
    return callAPI({url: "api/auth/sendResetPassword", ...params})
}

export type SavePasswordRequest = {
    token: string
    password: string
}

const savePassword: APIRequest<SavePasswordRequest> = (params) => {
    return callAPI({url: "/api/auth/resetPassword", ...params})
}

export interface LocalesResponse {
    locales?: {id: string; name: string}[]
}

const getAvailableLocales: APIRequest<null, LocalesResponse> = (params) => {
    return callAPI({url: "/api/auth/availableLocales", ...params})
}

export interface AuthSSOResponse {
    url: string
    ssoDisabled?: boolean
    noSsoInDistrict?: boolean
    noUser?: boolean
}

const sso_url: APIRequest<{email: string}, AuthSSOResponse> = (params) => {
    return callAPI({url: "/api/auth/sso_url", ...params})
}

export const authAPI = {
    reset,
    savePassword,
    getAvailableLocales,
    sso_url,
}
